define('components/photoset/layouts/fitColumn/processors/balance', [], function () {
    var threshold = 0.75;

    function Processor(options) {
        this.enable = ko.observable(options.enable).unwrap().default(true);
        this.columnsCount = ko.observable(options.columnsCount).unwrap();
        this.minItemsCount = this.columnsCount.mapSingle(function (count) { return Math.floor(count * threshold) });
    }

    Processor.prototype.process = function (rows) {
        if (this.enable()) {
            ko.ignoreDependencies(function () {
                if (rows.length > 1) {
                    var row = this._getNextRow(rows);

                    while (row != null) {
                        this._balanceRow(row, rows);
                        row = this._getNextRow(rows);
                    }
                }
            }, this, [this.columnsCount(), this.minItemsCount()]);
        }
    };

    Processor.prototype._balanceRow = function (row, rows) {
        var rowIdx = _(rows).indexOf(row),
            donors = rows.slice(0, rowIdx);

        var itemsCountToAdd = this.minItemsCount() - row.items().length,
            itemsToAdd = [],
            itemToAdd;

        do {
            itemToAdd = this._borrowItem(donors);

            if (itemToAdd != null)
                itemsToAdd.push(itemToAdd);
        } while (itemsToAdd.length < itemsCountToAdd && itemToAdd != null);

        _(itemsToAdd).each(function (item) {
            row.append(item);
        });
    };

    Processor.prototype._getNextRow = function (rows) {
        var hasDonors = _(rows).any(function (row) { return row.items().length > this.minItemsCount() }.bind(this));

        if (hasDonors)
            return _(rows).find(function (row) { return row.items().length < this.minItemsCount() }.bind(this));

        return null;
    };

    Processor.prototype._borrowItem = function (rows) {
        var row = _(rows).last();

        if (row.items().length > this.minItemsCount()) {
            return row.pop();
        } else if (rows.length > 1) {
            var item = this._borrowItem(rows.slice(0, rows.length - 1));

            if (item != null) {
                row.prepend(item);
                return row.pop();
            }

            return null;
        } else {
            return null;
        }
    };

    return Processor;
});